<button
	type="button"
	class="btn btn-sm d-inline-flex align-items-center justify-content-center gap-2 border bg-white text-nowrap"
	(click)="openDialog()"
>
	<i class="fa-regular fa-clock-rotate-left"></i>
	<span>Historical Details</span>
</button>
